import { Box, Container, Grid, Typography } from '@mui/material';

const testimonials = [
  {
    quote: "Rosta transformed how we handle compliance. What used to take days now takes minutes. The automated alerts alone saved us from two potential penalties.",
    author: 'Sarah Nkosi',
    role: 'HR Director, TechCorp SA',
  },
  {
    quote: "The skills development module alone is worth it. WSP/ATR submissions are effortless now. Our SETA audits have never gone smoother.",
    author: 'Johan van der Merwe',
    role: 'Operations Manager, Manufacturing Co',
  },
  {
    quote: "Finally, a platform that understands South African labour law. POPIA compliance built in, LRA schedules automated. This is what we've been waiting for.",
    author: 'Priya Patel',
    role: 'CEO, StartupHub',
  },
];

export function TestimonialsSection() {
  return (
    <Box sx={{ py: 12 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: '#f0f0f5',
              mb: 2,
            }}
          >
            Loved by HR Teams
          </Typography>
          <Typography variant="h6" sx={{ color: '#a0a5b5', fontWeight: 400 }}>
            See what our customers have to say
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {testimonials.map((t) => (
            <Grid size={{ xs: 12, md: 4 }} key={t.author}>
              <Box
                sx={{
                  p: 4,
                  borderRadius: 2,
                  border: '1px solid rgba(255,255,255,0.06)',
                  backgroundColor: 'rgba(18, 18, 31, 0.6)',
                  backdropFilter: 'blur(16px)',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s ease',
                  '&:hover': { borderColor: 'rgba(61, 122, 255, 0.2)' },
                }}
              >
                {/* Stars */}
                <Box sx={{ mb: 2, color: '#c9b107', fontSize: 18, letterSpacing: 2 }}>
                  ★★★★★
                </Box>

                <Typography
                  sx={{
                    color: '#a0a5b5',
                    lineHeight: 1.7,
                    mb: 3,
                    flex: 1,
                    fontStyle: 'italic',
                    fontSize: 15,
                  }}
                >
                  "{t.quote}"
                </Typography>

                <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.06)', pt: 3 }}>
                  <Typography sx={{ fontWeight: 600, color: '#f0f0f5', fontSize: 15 }}>
                    {t.author}
                  </Typography>
                  <Typography sx={{ color: '#a0a5b5', fontSize: 13 }}>
                    {t.role}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
